function normalizeBasePath(path) {
  if (!path) return "/";
  const trimmed = path.trim();
  if (!trimmed) return "/";
  const prefixed = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  const normalized = prefixed.replace(/\/{2,}/g, "/").replace(/\/$/, "");
  return normalized === "" ? "/" : normalized;
}

function detectBasePath() {
  const envBase = process.env.REACT_APP_ROUTER_BASENAME;
  if (envBase) {
    return normalizeBasePath(envBase);
  }
}

export const ROUTER_BASENAME = detectBasePath();

export function buildAppPath(path = "/") {
  return path;
}

export function getAssetUrl(relativePath = "") {
  const prefix =
    process.env.PUBLIC_URL || (ROUTER_BASENAME === "/" ? "" : ROUTER_BASENAME);
  if (!relativePath) {
    return prefix || "/";
  }
  const sanitized = relativePath.replace(/^\/+/, "");
  return `${prefix}/${sanitized}`.replace(/\/{2,}/g, "/");
}

export const API_BASE_URL = process.env.REACT_APP_API_URL;

// Operations Service URL (for SSH/WebSocket operations)
export const OPERATIONS_SERVICE_URL =
  process.env.REACT_APP_OPERATIONS_SERVICE_URL;


export const STATUS_COLORS = {
  active: "success",
  off: "secondary",
  new: "primary",
  archive: "warning",
  unknown: "info",
};

export const DROPLET_STATUS = {
  NEW: "new",
  ACTIVE: "active",
  OFF: "off",
  ARCHIVE: "archive",
};

export const RESOURCE_STATUS = {
  NEW: "new",
  ACTIVE: "active",
  STOPPED: "stopped",
  CREATING: "creating",
  DELETING: "deleting",
  ARCHIVE: "archive",
};

export const TASK_TYPES = {
  POWER_ON: "power_on",
  POWER_OFF: "power_off",
  REBOOT: "reboot",
  SHUTDOWN: "shutdown",
  SNAPSHOT: "snapshot",
  REBUILD: "rebuild",
  RENAME: "rename",
  PASSWORD_RESET: "password_reset",
  RESTORE: "restore",
};

export const RESOURCE_ACTIONS = {
  compute: ["start", "stop", "reboot", "restart", "destroy"],
  storage: ["attach", "detach", "resize", "destroy"],
  database: ["restart", "backup", "restore", "destroy"],
};

export const DEFAULT_PROVIDER = "digitalocean";
